export default __webpack_public_path__ + "static/media/campaign.c2236050.svg";